/**
 * https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Objets_globaux/Intl/Collator/compare
 * Intl collator is used to avoid special character specific sorting
 */
export const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base'
});
